<!-- YouTube skippable in-stream ad on the TV app -->
<app-tv-frame>
  <!-- START: TV screen -->
  <div class="yt-tvw-screen d-flex flex-column">
    <!-- Fixed copy: the countdown is the player's, not the author's. -->
    <span class="yt-tvw-chip"><strong>Sponsored</strong> &middot; 00:08</span>

    <!-- START: Creative and its QR code, side by side -->
    <div class="yt-tvw-stage d-flex flex-row">
      <div class="yt-tvw-player">
        <img
          *ngIf="thumbnailUrl; else noCreative"
          class="yt-tvw-creative"
          [src]="thumbnailUrl"
          alt=""
        />

        <ng-template #noCreative>
          <div class="yt-tvw-creative creative-missing">
            <ng-container *ngIf="isResolving; else askForVideo">
              Reading video formats&hellip;
            </ng-container>
            <ng-template #askForVideo>
              Add a {{ format }} video to see this preview
            </ng-template>
          </div>
        </ng-template>
      </div>

      <!-- Placeholder art: the code itself is generated by YouTube from the
           destination, so the preview only shows where it lands. -->
      <div class="yt-tvw-qr d-flex align-items-center justify-content-center">
        <span class="yt-tvw-qr-eye yt-tvw-qr-eye-tl"></span>
        <span class="yt-tvw-qr-eye yt-tvw-qr-eye-tr"></span>
        <span class="yt-tvw-qr-eye yt-tvw-qr-eye-bl"></span>
        <span class="yt-tvw-qr-label">QR code</span>
      </div>
    </div>
    <!-- END: Creative and its QR code -->

    <!-- START: Ad footer -->
    <div class="yt-tvw-bar d-flex flex-row align-items-center">
      <img
        class="yt-tvw-logo"
        src="assets/images/google-campaign-logos/collection/valamar-collection-512x512-color.png"
        alt=""
      />

      <div class="yt-tvw-copy d-flex flex-column">
        <span class="yt-tvw-headline">{{ headline }}</span>
        <span class="yt-tvw-url">{{ displayUrl }}</span>
      </div>

      <!-- The remote's two actions. Fixed copy, as the set draws them. -->
      <div class="yt-tvw-actions d-flex flex-row align-items-center">
        <span class="yt-tvw-pill yt-tvw-send d-flex flex-row align-items-center">
          <i class="bi bi-bell-fill"></i>
          <span>Send to phone</span>
        </span>
        <span class="yt-tvw-pill yt-tvw-skip d-flex flex-row align-items-center">
          <span>Skip Ad</span>
          <i class="bi bi-skip-end-fill"></i>
        </span>
      </div>
    </div>
    <!-- END: Ad footer -->
  </div>
  <!-- END: TV screen -->
</app-tv-frame>
